import {
    iconRequest,
    iconCalculator,
    iconPreAprobador,
    iconClient,
    iconSearch,
    iconDigitalSignature,
} from '../defaultValues';

const data = {
    role_0fe6e6e62e3a4915935ea0bc6ec0d9ff: [
        {
            id: 'gogo',
            icon: iconRequest,
            label: 'Solicitudes',
            to: '/app/credits',
        },
        {
            id: 'searcRequest',
            icon: iconSearch,
            label: 'Buscar Solicitud',
            to: '/app/reports/searchRequest',
        },
        {
            id: 'pre-aprobador',
            icon: iconPreAprobador,
            label: 'Pre-aprobador',
            to: '/app/pre-aprobador',
        },
        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            icon: iconDigitalSignature,
            label: 'Firma Electrónica',
            to: '/app/electronicSignature/ElectronicSignature',
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
        },
    ],
};
export default data;
